module.exports = __webpack_public_path__ + "static/media/Female Veterinarian.ed11f98c.jpg";